"use client";
import Image from "next/image";
import Link from "next/link";
import { setStoredState } from "@/services/stateStorage";
import { useSearchParams } from "next/navigation";

export default function SelectCity() {
  const params = useSearchParams();

  return (
    <div className="flex flex-col bg-[#2033ef] w-full items-center justify-center gap-5 pt-38 w-full">
      <Image
        src="/images/banner/escolha.svg"
        width={300}
        height={100}
        alt="Escolha a sua casa!"
        className="mb-5"
      />

      <Link
        href={
          params.get("hasRegister") === "false"
            ? "/cadastro?cidade=RJ"
            : "/home?cidade=RJ"
        }
        target="_self"
        onClick={() => {
          setStoredState("RJ");
        }}
      >
        <div className="flex justify-center items-center h-14 rounded-[40px] bg-[#31b1e1] text-white font-bold w-70 max-w-85 cursor-pointer">
          <h3>RIO DE JANEIRO</h3>
        </div>
      </Link>
      <Link
        href={
          params.get("hasRegister") === "false"
            ? "/cadastro?cidade=SP"
            : "/home?cidade=SP"
        }
        target="_self"
        onClick={() => {
          setStoredState("SP");
        }}
      >
        <div className="flex justify-center items-center h-14 rounded-[40px] bg-[#00813e] text-white font-bold w-70 max-w-85 cursor-pointer">
          <h3>SÃO PAULO</h3>
        </div>
      </Link>

      <Link
        href="https://www.sympla.com.br/casacazetv?tracking=SITE_INICIO"
        target="_blank"
      >
        <Image
          src="/images/ingressos_button_hero.svg"
          height={40}
          width={240}
          alt="Ticket"
          priority
        />
      </Link>
    </div>
  );
}
